// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Eja52","right":"Footer_right__3wDoi","buttons":"Footer_buttons__3VmF0"};